import { LeaveBalanceDTO } from "@/models/leave-balances.model";
import { ColumnDef } from "@tanstack/react-table";

// Leave Type	Entitlement	Taken	Balance
export const columns: ColumnDef<LeaveBalanceDTO>[] = [
  {
    accessorFn: (row) => row.leaveType.name,
    header: "Leave Type",
  },
  {
    accessorFn: (row) => row.totalDays,
    header: "Entitlement",
    cell: ({ row }) => {
      const totalDays = row.original.totalDays !== null
        ? row.original.totalDays
        : '-';

      return <span className="w-full">{totalDays}</span>;
    },
  },
  {
    accessorFn: (row) => row.usedDays,
    header: "Taken",
  },
  {
    accessorFn: (row) => row.totalDays - row.usedDays,
    header: "Balance",
    cell: ({ row }) => {
      const balance = row.original.totalDays
        ? row.original.totalDays - row.original.usedDays
        : row.original.totalDays === 0 ?
          0 : '-'
      return <span className="w-full">{balance}</span>;
    },
  },
];
